module.exports = __webpack_public_path__ + "img/desert-biome.86e1d1c2.jpg";